import React from 'react';
interface HighlightPoint {
  hook: string;
  text: string;
}
const points: HighlightPoint[] = [{
  hook: '¿Dolores sin causa clara?',
  text: 'Decodifica los órganos más vulnerables según tu fecha de nacimiento.'
}, {
  hook: '¿Patrones repetitivos?',
  text: 'Identifica el código emocional que dispara tus síntomas físicos.'
}, {
  hook: '¿Sin respuestas?',
  text: 'Recibe tu receta exacta de cristales y frecuencias según tu número maestro.'
}];
export function BonusHighlight() {
  return <section className="bg-black px-5 py-14 sm:px-8" data-id="element-25" data-mp="y47vjtvadtdi">
      <div className="mx-auto grid max-w-5xl items-center gap-9 md:grid-cols-[0.85fr_1.15fr] md:gap-12" data-id="element-26" data-mp="y4zsb80mdx5d">
        <div className="relative" data-id="element-27" data-mp="128foy4covxi2">
          
        </div>

        <div data-id="element-28" data-mp="176h3cbz678n7">
          <span className="inline-block rounded-full border border-gold/60 bg-gold/10 px-3 py-1.5 text-[10px] font-black uppercase tracking-[0.1em] text-gold sm:text-[11px]" data-id="element-29" data-mp="176zbo6z3xdbh">
            🔥 Súper Bono #3 — Gratis solo hoy
          </span>

          <h2 className="mt-4 font-display text-[24px] font-bold uppercase leading-tight text-white sm:text-[32px]" data-id="element-30" data-mp="3s3hv57npsmf0">
            Tu nombre sabe lo que tu médico no ve
          </h2>
          <p className="mt-3 text-[15px] leading-relaxed text-gold/90 sm:text-[16px]" data-id="element-31" data-mp="3n2bzp22o6l1s">
            Lo que los análisis clínicos no detectan, tu vibración personal lo revela.
          </p>

          <ul className="mt-6 space-y-4 border-t border-white/10 pt-6" data-id="element-32" data-mp="3d5zc8lxpx3fh">
            {points.map(p => <li key={p.hook} className="flex gap-3" data-id="element-33" data-mp="3966wnp9wpx0m">
                <span aria-hidden="true" className="mt-0.5 text-[14px] text-gold" data-id="element-34" data-mp="34ddrj0aj0mo0">
                  ✦
                </span>
                <p className="text-[14px] leading-relaxed text-white/75 sm:text-[15px]" data-id="element-35" data-mp="2zfm2qf56hgo1">
                  <strong className="font-black text-white" data-id="element-36" data-mp="2ugso2je5njma">{p.hook}</strong> {p.text}
                </p>
              </li>)}
          </ul>

          <p className="mt-6 flex items-center justify-center rounded-full bg-gold/90 px-5 py-3 text-center text-[12px] font-black uppercase leading-snug tracking-[0.08em] text-ink sm:text-[13px]" data-id="element-37" data-mp="2pir4lxcthiaa">
            El complemento perfecto para tu Manual de Autosanación
          </p>
        </div>
      </div>
    </section>;
}